import React from 'react'
import { Link } from 'react-router-dom'
import Lottie from 'react-lottie';

import { FEATURED_CATEGORY } from '../../../../Utilities/APIs'
import useFetch from '../../../../Utilities/Hooks/useFetch'
import RightArrow from '../../../../Assets/icons/arrow-right.svg'
import animation from '../../../../Assets/Lotties/categories-lottie.json'
import Image from '../../../Partials/Elements/Image/Image';

import './FeaturedCategory.css'
import { useSelector } from 'react-redux';

function FeaturedCategory() {

    //fc = feature category 
    const [fcData, catLoading] = useFetch(FEATURED_CATEGORY)


    const { consumer } = useSelector(state => state.auth)



    //toggle birds
    // const [bird, SetBird] = useState(false)
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };


    return (
        <section className="hs_category spt spb">
            <div className="container">
                <div className="row main_row">
                    <div className="col left">

                        <div className="header_img">
                            <Lottie
                                options={defaultOptions}
                            />
                        </div>
                        <div className='cat_head_wrap'>
                            {
                                consumer
                                    ?
                                    consumer.language === 'english'
                                        ?
                                        <h2 className='sc_title'>What is the <span>Topic</span> you are searching for?</h2>
                                        :
                                        <h2 className='sc_title'>আপনি কি বিষয়ে তথ্য <span>খোঁজ</span>  করতে চাচ্ছেন?</h2>
                                    :
                                    <h2 className='sc_title'>আপনি কি বিষয়ে তথ্য <span>খোঁজ</span>  করতে চাচ্ছেন?</h2>
                            }

                        </div>
                    </div>
                    <div className="col right">
                        <div className="row categories">
                            {fcData?.map((data) => (
                                <div className="col" key={data._id}>
                                    <Link to={`/subcategory/${data.category._id}`}>
                                        <div className="category">
                                            <div className="category_content">
                                                <div className="category_img">
                                                    <Image imgSrc={data.category.image} imgAlt={data.category.name} />
                                                </div>
                                                <div className="category_title">
                                                    {
                                                        consumer
                                                            ?
                                                            consumer.language === 'english'
                                                                ?
                                                                <h3>{data.category.engName}</h3>
                                                                :
                                                                <h3>{data.category.name}</h3>
                                                            :
                                                            <h3>{data.category.name}</h3>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                            {catLoading ? '...loading' : (
                                <div className="col">
                                    <div className="category">
                                        <div className="category_content">
                                            <div className="all_category">
                                                <Link to='/categories'>
                                                    {
                                                        consumer
                                                            ?
                                                            consumer.language === 'english'
                                                                ?
                                                                'View All'
                                                                :
                                                                'সব দেখুন'
                                                            :
                                                            'সব দেখুন'
                                                    }
                                                    
                                                </Link>
                                                <img src={RightArrow} alt="RightArrow" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </section>
    )
}

export default FeaturedCategory